import React from 'react';
import { connect } from 'react-redux';
import {Translate, I18n} from 'react-redux-i18n';
import axios from 'axios';
import { Navigate } from 'react-router';

import { Dialog, InputGroup, TextArea, Icon, ContextMenu, Menu, MenuItem, Tab, Tabs } from '@blueprintjs/core';
// import { IconNames } from '@blueprintjs/icons';
import { 
    // MultiSelect,
    Select
} from '@blueprintjs/select';

import {
    openPreviewDialog as openPreviewDialogAction,
    closePreviewDialog as closePreviewDialogAction,
    openPreviewSingleDialog as openPreviewSingleDialogAction,
    closePreviewSingleDialog as closePreviewSingleDialogAction,
} from '../ExerciseBenchmark/ExerciseBenchmarkActions';

import {
    setBenchmark as setBenchmarkAction
} from '../Exercise/ExerciseActions';

import {
    setContributionBenchmark as setContributionBenchmarkAction,
    openEditContributionDialog as openEditBenchmarkContributionDialogAction,
} from './MutualAidActions'

import Loading from '../../components/Loading/Loading';
import EditContributeDialog from './EditContributionDialog';
import PreviewBenchmarkDialog from '../ExerciseBenchmark/PreviewDialog';
import EditBenchmarkContributionDialog from './EditBenchmarkContributionDialog';
import PreviewSingleBenchmarkDialog from '../ExerciseBenchmark/PreviewSingleDialog';
import auth from '../../auth';
import helpers from '../../helpers';

import styles from './MutualAid.module.css';

import defaultThumbnail from '../../assets/img/default-thumbnail.png';
import playOverlay from '../../assets/img/play_overlay.png';

class MutualAid extends React.Component {
    
    constructor() {
        super();
        
        this.viewSim = this.viewSim.bind(this);
        this.downloadFiles = this.downloadFiles.bind(this);
        this.limitText = this.limitText.bind(this);
        this.loadMore = this.loadMore.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.setFilteredUser = this.setFilteredUser.bind(this);
        this.postComment = this.postComment.bind(this);
        this.rateSim = this.rateSim.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteComment = this.deleteComment.bind(this);
        this.showContextMenu = this.showContextMenu.bind(this);
        this.showBenchmark = this.showBenchmark.bind(this);
        this.handleEditBenchmark = this.handleEditBenchmark.bind(this);
        this.handleDeleteBenchmark = this.handleDeleteBenchmark.bind(this);
        this.importBenchmark = this.importBenchmark.bind(this);
        this.setFilteredCompany = this.setFilteredCompany.bind(this);
        
        this.state = {
            repos: [],
            allContributedCount: 0,
            categories: [],
            isLoading: true,
            currentSim: null,
            filterText: "",
            filterCategories: [],
            filterUser: null,
            sortBy: null,
            sortDirection: null,
            currentPage: 1,
            hasMore: true,
            loadingComments: false,
            simulationComments: [],
            currentComment: "",
            currentRating: 0,
            isMaster: false,
            scenarioToEdit: null,
            isContextMenuOpen: false,
            searchCount: null,
            benchmarks: [],
            benchmarksCount: 0,
            currentTab: 'simulations',
            filterCompany: null,
            benchmarksSearchCount: 0,
            benchmarksHasMore: true,
            benchmarkToEdit: null,
        }
        
        this.categoryFilterRef = React.createRef();
        this.mutualAidTextRef = React.createRef();
    }
    
    componentDidMount() {
        (async ()=> {
            try {
                const responses = await Promise.all([
                    axios.get('/api/scenarios/contribute', {
                        headers: {
                            'Authorization': window.localStorage.getItem("token")
                        },
                        validateStatus: (status) => status < 500
                    }),
                    axios.get('/api/category', {
                        headers: {
                            'Authorization': window.localStorage.getItem("token")
                        },
                        validateStatus: (status) => status < 500
                    }),
                    axios.get('/api/scenarios/contribute/count', {
                        headers: {
                            'Authorization': window.localStorage.getItem("token")
                        },
                        validateStatus: (status) => status < 500
                    }),
                    axios.get('/api/companies/benchmarks/contribute', {
                        headers: {
                            'Authorization': window.localStorage.getItem("token")
                        },
                        validateStatus: (status) => status < 500
                    })
                ])
                console.log(responses[0].status)
                if(responses[0].status > 400) {
                  auth.logoutAndRedirect();
                  throw new Error('Not authenticated.');
                }
                console.log("Response:", responses[0].status, responses[0].data);
                console.log("Categories", responses[1].status, responses[1].data);
                console.log("Mutual Aid Count", responses[2].status, responses[2].data);
                console.log("MA Benchmarks", responses[3].status, responses[3].data);
                this.setState({
                    repos: responses[0].data.scenarios,
                    categories: responses[1].data.categories,
                    allContributedCount: responses[2].data.count,
                    benchmarks: responses[3].data.benchmarks,
                    benchmarksCount: responses[3].data.count,
                })
            } catch (err) {
                console.error(err)
            } finally {
                this.setState({isLoading: false})
            }
        })();
        if(auth.can('scenario-master')) {
            this.setState({isMaster: true})
        }
        console.log("the node", this.mutualAidTextRef);
    }
    
    viewSim (repo) {
        let url = repo.archiveURL;
        // viewSim (simulation, companyId) {
        //  window.open(`/embeddedplayer?s=${simulation}&c=${companyId}&t=${window.localStorage.token}`,
        window.open(`/webclient/?url=${encodeURIComponent(url)}` + (window.localStorage.token ? `&token=${window.localStorage.token}` : ""),
        '_blank', "directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=430,height=342");
        
        // axios.post(`/api/scenarios/${simulation}/view`, {}, {
        axios.post(`/api/scenarios/${repo._id}/view`, {}, {
            headers: {
                'Authorization': window.localStorage.getItem("token")
            },
        })
        .catch((err)=>console.error(err))
    }
    
    downloadFiles() {
        window.open(this.state.currentSim.filesURL, '_blank');
        axios.post(`/api/scenarios/${this.state.currentSim._id}/log-download`, {}, {
            headers: {
                'Authorization': window.localStorage.getItem("token")
            },
        })
        .catch((err)=>console.error(err))
    }
    
    limitText(text) {
        if(text.length > 50) {
            return text.substring(0, 50) + '...';
        }
        return text;
    }
    
    async handleSearch() {
        try {
            const [reposResponse, benchmarksResponse] = await Promise.all([
                axios.get('/api/scenarios/contribute', {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    },
                    params: {
                        page: 1,
                        searchTerm: this.state.filterText,
                        categories: this.state.filterCategories.length? JSON.stringify(this.state.filterCategories) : null,
                        userId: this.state.filterUser? this.state.filterUser.id._id : null,
                        sortBy: this.state.sortBy,
                        sortDirection: this.state.sortDirection,
                        
                    },
                    validateStatus: (status) => status < 400
                }),
                axios.get('/api/companies/benchmarks/contribute', {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    },
                    params: {
                        page: 1,
                        searchTerm: this.state.filterText,
                        categories: this.state.filterCategories.length? JSON.stringify(this.state.filterCategories) : null,
                        companyId: this.state.filterCompany,
                        // sortBy: this.state.sortBy,
                        // sortDirection: this.state.sortDirection,
                    },
                    validateStatus: (status) => status < 400
                })
            ])
            this.setState({
                currentPage: 1,
                repos: reposResponse.data.scenarios,
                searchCount: reposResponse.data.count,
                hasMore: reposResponse.data.scenarios.length > 0
            });
            this.setState({
                benchmarks: benchmarksResponse.data.benchmarks,
                benchmarksCount: benchmarksResponse.data.count,
                benchmarksSearchCount: benchmarksResponse.data.count,
                benchmarksHasMore: benchmarksResponse.data.benchmarks.length > 0
            });
        } catch (err) {
            console.error(err)
        }
    }
    
    async loadMore() {
        try {
            const [reposResponse, benchmarksResponse] = await Promise.all([
                axios.get('/api/scenarios/contribute', {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    },
                    params: {
                        page: this.state.currentPage + 1,
                        searchTerm: this.state.filterText,
                        categories: this.state.filterCategories.length? JSON.stringify(this.state.filterCategories) : null,
                        userId: this.state.filterUser? this.state.filterUser.id._id : null,
                        sortBy: this.state.sortBy,
                        sortDirection: this.state.sortDirection,
                    },
                    validateStatus: (status) => status < 400
                }),
                axios.get('/api/companies/benchmarks/contribute', {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    },
                    params: {
                        page: this.state.currentPage + 1,
                        searchTerm: this.state.filterText,
                        categories: this.state.filterCategories.length? JSON.stringify(this.state.filterCategories) : null,
                        companyId: this.state.filterCompany,
                        // sortBy: this.state.sortBy,
                        // sortDirection: this.state.sortDirection,
                    },
                    validateStatus: (status) => status < 400
                })
            ]);
            const repos = reposResponse.data.scenarios;
            const benchmarks = benchmarksResponse.data.benchmarks;
            console.log("BENCHMARKS LOAD MORE", benchmarks);
            if(repos.length === 0) {
                this.setState({hasMore: false})
            }
            if(benchmarks.length === 0) {
                this.setState({benchmarksHasMore: false})
            }
            return this.setState((prevState)=>({
                repos: prevState.repos.concat(repos),
                benchmarks: prevState.benchmarks.concat(benchmarks),
                currentPage: prevState.currentPage + 1
            }))
        } catch (err) {
            console.error(err);
        }
    }
    
    setFilteredUser(user) {
        this.setState({
            filterUser: user
        }, ()=> {
            this.handleSearch()
        })
    }
    
    setFilteredCompany(company) {
        this.setState({
            filterCompany: company
        }, () => {
            this.handleSearch();
        })
    }
    
    showDetails(repo) {
        this.setState({currentSim: repo, commentsLoading: true}, async ()=>{
            try {
                const responses = await Promise.all([
                    axios.get(`/api/scenarios/${repo._id}/comments`, {
                        headers: {
                            'Authorization': window.localStorage.getItem("token")
                        },
                    }),
                    axios.get(`/api/scenarios/${repo._id}/rating`, {
                        headers: {
                            'Authorization': window.localStorage.getItem("token")
                        },
                    }),
                ])
                this.setState({
                    simulationComments: responses[0].data.comments,
                    currentRating: responses[1].data.rating? responses[1].data.rating.rating : 0
                })
            } catch (err) {
                console.error(err)
            } finally {
                this.setState({commentsLoading: false})
            }
        })
    }
    
    showBenchmark(benchmark) {
        this.props.openPreviewSingleDialog(benchmark);
    }
    
    async postComment() {
        try {
            const response = await axios.post(`/api/scenarios/${this.state.currentSim._id}/comments`, {
                content: this.state.currentComment
            }, {
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            })
            console.log("Created Comment", response.data)
            const createdComment = response.data.comment;
            createdComment.user = JSON.parse(window.localStorage.getItem("user"))
            this.setState({
                currentComment: "",
                simulationComments: this.state.simulationComments.concat(createdComment)
            })
        } catch (err) {
            console.error(err)
        }
    }
    
    async rateSim(value) {
        try {
            const response = await axios.post(`/api/scenarios/${this.state.currentSim._id}/rating`, {
                rating: value
            }, {
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            })
            // console.log("RATING RESPONSE", response.data);
            const {scenario, rating} = response.data;
            this.setState({
                currentSim: {...this.state.currentSim, totalRatingValue: scenario.totalRatingValue, totalRatingUsers: scenario.totalRatingUsers},
                currentRating: rating.rating
            })
        } catch (err) {
            console.error(err)
        }
    }
    
    handleEdit(repo) {
        this.setState({
            scenarioToEdit: repo  
        })
    }
    
    handleEditBenchmark(benchmark) {
        console.log("Handling edit benchmark", benchmark);
        this.props.setContributionBenchmark(benchmark);
        this.props.openEditBenchmarkContributionDialog()
    }
    
    async handleDelete(repo) {
        const confirmation = confirm("Are you sure you want to delete this scenario?")
        if(!confirmation) { return; }
        try {
            const response = await axios.delete(`/api/scenarios/contribute/${repo._id}`, {
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            });
            this.setState((prevState)=>({repos: prevState.repos.filter((scenario)=>scenario._id !== repo._id)}))
        } catch (err) {
            console.error(err);
        }
    }
    
    async handleDeleteBenchmark(benchmark) {
        const confirmation = confirm("Are you sure you want to delete this evaluation");
        if(!confirmation) return;
        try {
            const response = await axios.delete(`/api/companies/benchmarks/contribute/${benchmark._id}`, {
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            });
            if(response.status !== 204) {
                console.error(response.status, response.data);
                alert("Failed to delete evaluation");
                return;
            }
            this.setState((prevState)=>({benchmarks: prevState.benchmarks.filter((b) => b._id !== benchmark._id), benchmarksCount: prevState.benchmarksCount - 1}))
            alert("Evaluation deleted successfully");
        } catch (err) {
            console.error(err);
            alert("Failed to delete benchmark");
        }
    }
    
    importSim(repo) {
        // console.log("IMPORTING", {company_id: process.env.REACT_APP_MUTUAL_AID_COMPANY_ID, scenario_id: repo._id});
        const confirmation = confirm("Are you sure you want to import this simulation?");
        if(!confirmation) return;
        (async ()=>{
            try {
                const response = await axios.post('/api/companies/import-repo-sim', {
                    company_id: repo.companyId,
                    scenario_id: repo._id,
                }, {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    },
                    validateStatus: (status) => status < 401
                })
                if(response.status < 400) {
                    console.log("RESPONSE", response.status, response.data);
                    alert("Simulation imported successfully");
                } else {
                    alert(response.data.error);
                }
            } catch (err) {
                console.error(err);
                alert("Simulation import failed");
            }
        })();
    }
    
    importBenchmark(benchmark) {
        (async ()=>{
            try {
                const response = await axios.post('/api/companies/benchmarks/import-contributed', {
                    id: benchmark._id
                }, {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    },
                    validateStatus: (status) => status < 401
                });
                if(response.status !== 201) {
                    console.log("RESPONSE", response.status, response.data);
                    return alert(response.data.error);
                }
                alert("Evaluation imported successfully");
            } catch (err) {
                console.error(err);
                alert("Evaluation import failed");
            }
        })();
    }
    
    async deleteComment(commentId) {
        const confirmation = confirm("Are you sure you want to delete this comment");
        if(!confirmation) return;
        
        try {
            await axios.delete(`/api/scenarios/${this.state.currentSim._id}/comments`, {
                params: {
                    commentId
                },
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            })
            this.setState((prevState)=>({simulationComments: prevState.simulationComments.filter((entry)=>entry._id !== commentId)}));
        } catch (err) {
            console.error(err);
        }
    }
    
    showContextMenu() {
        // console.log("REF:", this.categoryFilterRef);
        // const categories = this.state.categories.filter((category)=>!!!category.parent);
        ContextMenu.show(
            <div style={{display: 'flex', padding: '10px'}}>
                {
                    this.state.categories
                    .filter((category)=>!!!category.parent)
                    .map((mainCategory) => (
                        <div style={{flex: 1, display: 'flex', flexDirection: 'column', margin: '0px 4px'}} key={"option-category-"+mainCategory._id}>
                            <h5 
                                className="pointer"
                                style={{...((this.state.filterCategories.includes(mainCategory._id)? {color: 'grey'} : {})), fontWeight: 'bold'}}
                                onClick={()=>{
                                    if(this.state.filterCategories.includes(mainCategory._id)) return;
                                    this.setState({filterCategories: this.state.filterCategories.concat(mainCategory._id)});
                                    this.showContextMenu();
                                }}
                                
                            >{mainCategory.name}</h5>
                            {
                                this.state.categories
                                .filter((category)=>category.parent === mainCategory._id)
                                .map((subcategory)=>(
                                    <div
                                        key={"option-category-"+subcategory._id}
                                        className="pointer"
                                        style={(this.state.filterCategories.includes(mainCategory._id) || this.state.filterCategories.includes(subcategory._id)? {color: 'grey'}: {})}
                                        onClick={()=>{
                                            if(this.state.filterCategories.includes(mainCategory._id) || this.state.filterCategories.includes(subcategory._id)) return;
                                            this.setState({filterCategories: this.state.filterCategories.concat(subcategory._id)});
                                            this.showContextMenu();
                                        }}
                                    >{subcategory.name}</div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>,
            { 
                left: this.categoryFilterRef.current.getBoundingClientRect().left,
                top: this.categoryFilterRef.current.getBoundingClientRect().top + this.categoryFilterRef.current.offsetHeight + 5 
            },
            ()=>this.setState({isContextMenuOpen: false})
        );
        
        this.setState({isContextMenuOpen: true});
    }
    
    handleSort(sortBy, sortDirection) {
        this.setState({sortBy, sortDirection },  ()=> {
            this.handleSearch();
        })
    }
    
    render() {
        
        
        const user = helpers.getUserFromLocalStorage();
        
        if (user && user?.company && user?.company?.hideMutualAid) {
            return <Navigate to="/" />
        }
        
        const FilterMenu = (
            <Menu>
                <MenuItem text="Views Desc" onClick={()=>this.handleSort("views", "desc")} />
                <MenuItem text="Views Asc" onClick={()=>this.handleSort("views", "asc")} />
                <MenuItem text="Downloads Desc" onClick={()=>this.handleSort("downloads", "desc")} />
                <MenuItem text="Downloads Asc" onClick={()=>this.handleSort("downloads", "asc")} />
                <MenuItem text="Clear Filter" onClick={()=>this.handleSort(null, null)} />
            </Menu>
        )
        
        return (
            <div className="row">
                <PreviewBenchmarkDialog />
                <PreviewSingleBenchmarkDialog />
                <EditBenchmarkContributionDialog
                    onUpdated={(benchmark)=>{
                        this.setState((prevState)=>({
                            benchmarks: prevState.benchmarks.reduce((acc, value) => {
                                if(value._id === benchmark._id) {
                                    return acc.concat(benchmark);
                                }
                                return acc.concat(value);
                            }, [])
                        }))
                    }}
                />
                <div className="col-md-12 mt-4">
                    { this.state.isLoading && <Loading /> }
                    <Dialog 
                        autoFocus={true}
                        canEscapeKeyClose={true}
                        canOutsideClickClose={true}
                        enforceFocus={true}
                        isOpen={this.state.currentSim}
                        usePortal= {true}
                        onClose={()=>this.setState({currentSim: null, simulationComments: [], currentComment: ""})}
                        title={<span style={{color: 'white'}}>Simulation Details</span>}
                      >
                        {
                            this.state.currentSim?
                            <div className={`column ${styles.spacer}`}>
                                {/*<h4>Title</h4>
                                <p>{this.state.currentSim.title}</p>*/}
                                <h3>{this.state.currentSim.title}</h3>
                                <div><strong><span style={{fontSize: 16}}>Author: </span>{this.state.currentSim.contributedBy?.name}</strong></div>
                                <div><strong><span style={{fontSize: 16}}>Company: </span>{this.state.currentSim.contributedBy?.id?.company?.name}</strong></div>
                                <h4>Description</h4>
                                <p>{this.state.currentSim.description}</p>
                                {
                                    (()=>{
                                        const totalRatings = this.state.currentSim.totalRatingValue || 0;
                                        const totalRaters = this.state.currentSim.totalRatingUsers || 0;
                                        const finalRating = totalRaters === 0? 0 : (totalRatings/totalRaters);
                                        return (
                                            <div>
                                                <div>
                                                    <h6>Average Rating: {finalRating === 5? "5" : finalRating.toFixed(1)}/5</h6>
                                                </div>
                                                <div>
                                                    <h6>My Rating</h6>
                                                    <Icon icon={this.state.currentRating < 1? "star-empty" : "star"} onClick={()=>this.rateSim(1)} />
                                                    <Icon icon={this.state.currentRating < 2? "star-empty" : "star"} onClick={()=>this.rateSim(2)} />
                                                    <Icon icon={this.state.currentRating < 3? "star-empty" : "star"} onClick={()=>this.rateSim(3)} />
                                                    <Icon icon={this.state.currentRating < 4? "star-empty" : "star"} onClick={()=>this.rateSim(4)} />
                                                    <Icon icon={this.state.currentRating < 5? "star-empty" : "star"} onClick={()=>this.rateSim(5)} />
                                                </div>
                                            </div>
                                        )
                                    })()
                                }
                                {
                                    this.state.isMaster &&
                                    <div>
                                        <div><strong>Views: {this.state.currentSim.views || "0"}</strong></div>
                                        <div><strong>Downloads: {this.state.currentSim.downloads || "0"}</strong></div>
                                    </div>
                                }
                                {
                                    this.state.currentSim.filesURL?
                                    <button className="btn btn-primary" onClick={this.downloadFiles}><Translate value="mutualAid.DownloadFiles"/></button>
                                    :
                                    null
                                }
                                <br />
                                <h3>Comments</h3>
                                {
                                    this.state.simulationComments.map((comment)=>(
                                        <div style={{display: 'flex'}} key={"comment-"+comment._id}>
                                            <p style={{flex: 9}}>
                                                <strong>{comment.user?.name}:</strong>
                                                <br />{comment.content}
                                            </p>
                                            {
                                                ((comment.user?._id === user?.id) || this.state.isMaster) &&
                                                <div onClick={()=>this.deleteComment(comment._id)} className="pointer">x</div>
                                            }
                                        </div>
                                    ))
                                }
                                <TextArea
                                    onChange={(event)=>this.setState({currentComment: event.target.value})}
                                    value={this.state.currentComment}
                                    style={{marginBottom: 3}}
                                />
                                <div className="row" style={{justifyContent: 'flex-end', marginTop: 5, marginRight: 0, marginLeft: 0}}>
                                    <button className="btn btn-primary yellow-white-fit-btn" onClick={this.postComment}><Translate value="mutualAid.PostComment"/></button>
                                </div>
                            </div>
                            :
                            null
                        }
                    </Dialog>
                    <Dialog 
                        autoFocus={true}
                        canEscapeKeyClose={true}
                        canOutsideClickClose={true}
                        enforceFocus={true}
                        isOpen={this.state.scenarioToEdit}
                        usePortal= {true}
                        onClose={()=>this.setState({scenarioToEdit: null})}
                        title="Contribute"
                    >
                        <EditContributeDialog 
                            scenario={this.state.scenarioToEdit}
                            onClose={(updatedScenario)=>this.setState({
                                scenarioToEdit: null
                            }, ()=>{
                                this.handleSearch();
                            })} 
                            onFilesDeleted={()=>{
                                this.setState((prevState)=>({
                                    repos: prevState.repos.map((repo)=>{
                                        if(repo._id === prevState.scenarioToEdit._id) {
                                            delete repo.filesURL;
                                        }
                                        return repo;
                                    })
                                }))
                            }}
                        />
                    </Dialog>
                    <h3><strong><Translate value="mutualAid.Title"/></strong></h3>
                    <hr />
                    <h4><strong><Translate value="mutualAid.Text" /><a href="https://simsushare.com/mutual-aid/" target="_blank"><Translate value="mutualAid.Here" /></a></strong></h4>
                    <div className="row" style={{margin: '13px 0px', background: '#ffc235', justifyContent: 'flex-end', alignItems: 'center', padding: '10px 20px'}}>
                        <div style={{flexGrow: 1, fontSize: 15}}>
                            {
                                this.state.currentTab === 'simulations'?
                                <React.Fragment><Translate value="common.Search" /> {this.state.searchCount !== null? this.state.searchCount : this.state.allContributedCount} <Translate value="common.Scenarios" /></React.Fragment>
                                :
                                <React.Fragment><Translate value="common.Search" /> {this.state.benchmarksCount} <Translate value="exercise.Benchmarks" /></React.Fragment>
                            }
                        </div>
                        <InputGroup
                            // placeholder={`Search ${this.state.allContributedCount} scenarios`}
                            placeholder={`Search`}
                            onChange={(event)=>{
                                event.persist();
                                this.setState({filterText: event.target.value});
                            }}
                            onKeyDown={(event)=>{
                                if(event.key === 'Enter'){
                                    this.handleSearch()
                                }
                            }}
                            value={this.state.filterText}
                        />
                        {/* <MultiSelect
                            items={this.state.categories.filter((category)=>!!!this.state.filterCategories.find((entry)=>entry._id === category._id))}
                            itemRenderer={(category, {modifiers, handleClick})=>(
                                <MenuItem
                                    active={modifiers.active}
                                    onClick={handleClick}
                                    key={category._id}
                                    text={category.name}
                                    shouldDismissPopover={false}
                                />
                            )}
                            tagRenderer={(category)=>category.name}
                            selectedItems={this.state.filterCategories}
                            onItemSelect={(category)=>{
                                this.setState({filterCategories: this.state.filterCategories.concat(category)})
                            }}
                            itemsEqual={(a,b)=>a._id === b._id}
                            tagInputProps={{
                                onRemove: (tag, index)=>{
                                    this.setState((prevState)=>({filterCategories: prevState.filterCategories.slice(0, index).concat(prevState.filterCategories.slice(index + 1))}))
                                }
                            }}
                            onKeyDown={(event)=>event.preventDefault()}
                        /> */}
                        {/*
                        <select multiple onChange={(event)=>console.log("Select is not", event.target.value)}>
                            {
                                this.state.categories
                                .filter((category)=>!this.state.filterCategories.includes(category._id))
                                .map((category)=>(
                                    <option key={category._id}>{category.name}</option>
                                ))
                            }
                        </select>
                        */}
                        <div className="form-control" onClick={()=>{this.showContextMenu()}} ref={this.categoryFilterRef} style={{width: 400, minHeight: 30, height: 'fit-content', display: 'flex', flexWrap: 'wrap', margin: '0px 5px'}}>
                            {
                                this.state.filterCategories.length === 0 &&
                                <div style={{position: 'absolute', color: '#bbb'}}>Filter By Category</div>
                            }
                            {
                                this.state.filterCategories.map((categoryId) => (
                                    <div style={{background: 'grey', color: 'white', margin: '2px 4px', padding: '3px', borderRadius: 4, width: 'fit-content' }} key={"selected-"+categoryId}>
                                        <span>{this.state.categories.find((category)=>category._id === categoryId).name}</span>
                                        <span 
                                            onClick={
                                                (event)=>{
                                                    event.stopPropagation();
                                                    this.setState({filterCategories: this.state.filterCategories.filter((catId) => catId !== categoryId )});
                                                }
                                            }
                                            style={{marginLeft: 3}}
                                            className="pointer"
                                        >x</span>
                                    </div>
                                ))
                            }
                        </div>
                        <button className="btn btn-primary" style={{height: 'fit-content', color: 'white', marginRight: 5}} onClick={this.handleSearch}><i className="fas fa-search" /></button>
                        <button className="btn btn-primary" style={{height: 'fit-content', color: 'white'}} onClick={()=>{this.setState({filterText: "", filterCategories: [], filterUser: null, filterCompany: null}, ()=>this.handleSearch());}}><i className="fas fa-eraser" /></button>
                        {/*
                            this.state.searchCount !== null && <strong>{this.state.searchCount} simulations found</strong>
                        */}
                        {
                            this.state.filterUser &&
                            <div><strong>{this.state.filterUser.name}</strong> <span className="pointer" onClick={()=>this.setFilteredUser(null)}>x</span></div>
                        }
                        {
                            this.state.isMaster &&
                            <select 
                                onChange={(e)=>e.target.value === ""? this.handleSort(null, null) : this.handleSort(...e.target.value.split("-"))}
                                value={this.state.sortBy? (this.state.sortBy+"-"+this.state.sortDirection) : ""}
                            >
                                <option value="">None</option>
                                <option value="views-desc">Views Descending</option>
                                <option value="views-asc">Views Ascending</option>
                                <option value="downloads-desc">Downloads Descending</option>
                                <option value="downloads-asc">Downloads Ascending</option>
                            </select>
                        }
                    </div>
                    {
                        !process.env.REACT_APP_HIDE_BENCHMARKS
                        &&
                        <div>
                            <Tabs onChange={(newTab)=>this.setState({currentTab: newTab})}>
                                <Tab id="simulations" title="Simulations" />
                                <Tab id="benchmarks" title="Evaluations" />
                            </Tabs>
                        </div>
                    }
                    <div className="row wrap" style={{justifyContent: 'center', width: '100%'}}>
                    {
                        this.state.currentTab === 'simulations'?
                        (
                            this.state.repos.length === 0 &&
                            <div style={{display: 'flex', justifyContent: 'center', marginTop: 50, fontSize: 32}}><Translate value="mutualAid.NoSimulations" /></div>
                        )
                        :
                        (
                            this.state.benchmarks.length === 0 &&
                            <div style={{display: 'flex', justifyContent: 'center', marginTop: 50, fontSize: 32}}><Translate value="mutualAid.NoBenchmarks" /></div>
                        )
                    }
                    {
                        this.state.currentTab === 'simulations'?
                        this.state.repos.map((repo)=>(
                            <div className={`${styles.repoEntry} column centered ${styles.spacer}`} style={{justifyContent: 'flex-start'}} key={repo._id}>
                                <div className={`${styles.thumbContainer} pointer`} onClick={()=>this.viewSim(repo)}>
                                    <img src={repo.thumbnailURL || defaultThumbnail} alt="Thumbnail" className={`${styles.thumb}`} />
                                    <img src={playOverlay} className={`${styles.thumbOverlay}`} />
                                </div>
                                <div className={styles.thumbInnerContainer}>
                                    <div className={styles.extraPadding} style={{fontSize: 18}}><strong>{repo.title}</strong></div>
                                    {/*<div>
                                        <button className="btn btn-primary" onClick={()=>this.viewSim(repo._id)}>
                                          <Translate value="mutualAid.ViewSim"/>
                                        </button>
                                    </div>*/}
                                    <div className={`${styles.descriptionContainer} ${styles.extraPadding}`}>{this.limitText(repo.description)}</div>
                                    <div className={styles.extraPadding}>
                                        <span>Author: </span>
                                        <span onClick={
                                            ()=>{
                                                repo.contributedBy?.id?.company?.name && this.setFilteredUser(repo.contributedBy)
                                            }
                                        }
                                            className="pointer"
                                            style={{color: repo.contributedBy?.id?.company?.name? 'blue' : 'inherit'}}
                                        >
                                            {repo.contributedBy.name}
                                        </span>
                                    </div>
                                    {
                                        !!(repo.contributedBy?.id?.company?.name) &&
                                        <div className={styles.extraPadding}>
                                            <span>Company: </span>
                                            <span>
                                                {repo.contributedBy?.id?.company?.name}
                                            </span>
                                        </div>
                                    }
                                    <div>
                                        <button className="btn btn-text-primary" onClick={()=>this.showDetails(repo)}>
                                          <strong><Translate value="mutualAid.ShowDetails"/></strong>
                                        </button>
                                    </div>
                                    {
                                        this.state.isMaster &&
                                        <div className={"column"}>
                                            <div style={{margin: '3px 0px'}}>
                                                <button className="btn btn-text-danger" onClick={()=>this.handleEdit(repo)}><strong>Edit</strong></button>
                                            </div>
                                            <div>
                                                <button className="btn btn-text-danger" onClick={()=>this.handleDelete(repo)}><strong>Delete</strong></button>
                                            </div>
                                        </div>   
                                    }
                                    {
                                        (this.state.isMaster || user.level === 'admin') &&
                                        <div className={styles.lessExtraPadding}>
                                            <button className="btn btn-primary yellow-white-fit-btn" style={{width: '100%', color: 'white'}} onClick={()=>this.importSim(repo)}>
                                              <i className="fas fa-fw fa-download"/> <Translate value="scenarios.ImportRepoSim"/>
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        ))
                        :
                        this.state.benchmarks.map((benchmark) => (
                            <div className={`${styles.repoEntry} column centered ${styles.spacer}`} style={{justifyContent: 'flex-start'}} key={benchmark._id}>
                                <div className={styles.thumbInnerContainer}>
                                    <div
                                        className={styles.extraPadding + " pointer"}
                                        style={{fontSize: 18}}
                                        onDoubleClick={()=>this.showBenchmark(benchmark)}
                                    >
                                        <strong>{benchmark.name}</strong>
                                    </div>
                                    {/*<div>
                                        <button className="btn btn-primary" onClick={()=>this.viewSim(repo)}>
                                          <Translate value="mutualAid.ViewSim"/>
                                        </button>
                                    </div>*/}
                                    <div className={`${styles.descriptionContainer} ${styles.extraPadding}`}>{this.limitText(benchmark.contribution.description)}</div>
                                    <div className={styles.extraPadding}>
                                        <span>Author: </span>
                                        <span>
                                            {benchmark.contribution.user}
                                        </span>
                                    </div>
                                    <div className={styles.extraPadding}>
                                        <span>Company: </span>
                                        <span
                                            onClick={()=>benchmark.company? this.setFilteredCompany(benchmark.company) : null}
                                            className="pointer"
                                            style={{color: benchmark.company? 'blue' : 'inherit'}}
                                        >
                                            {benchmark.contribution.company}
                                        </span>
                                    </div>
                                    <div>
                                        <button className="btn btn-text-primary" onClick={()=>this.showBenchmark(benchmark)}>
                                          <strong><Translate value="mutualAid.ShowBenchmark"/></strong>
                                        </button>
                                    </div>
                                    {
                                        this.state.isMaster &&
                                        <div className={"column"}>
                                            <div style={{margin: '3px 0px'}}>
                                                <button className="btn btn-text-danger" onClick={()=>this.handleEditBenchmark(benchmark)}><strong>Edit</strong></button>
                                            </div>
                                            <div>
                                                <button className="btn btn-text-danger" onClick={()=>this.handleDeleteBenchmark(benchmark)}><strong>Delete</strong></button>
                                            </div>
                                        </div>   
                                    }
                                    {
                                        (this.state.isMaster || user.level === 'admin') &&
                                        <div className={styles.lessExtraPadding}>
                                            <button className="btn btn-primary yellow-white-fit-btn" style={{width: '100%', color: 'white'}} onClick={()=>this.importBenchmark(benchmark)}>
                                              <i className="fas fa-fw fa-download"/> <Translate value="mutualAid.ImportBenchmark"/>
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        ))
                    }
                    </div>
                    {
                        (this.state.currentTab === 'simulations'? this.state.hasMore : this.state.benchmarksHasMore) &&
                        <div className="row" style={{justifyContent: 'center', marginTop: 20, width: '100%'}}>
                            <button className={"btn btn-primary row centered"} style={{width: '50%', color: 'white'}} onClick={this.loadMore}>
                                Load More
                                <svg style={{marginLeft: 10, marginTop: -1}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-caret-right-fill" viewBox="0 0 16 16">
                                  <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                                </svg>
                            </button>
                        </div>
                    }
                </div>
            </div>
        )
    }
    
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = ({
    openPreviewDialog: openPreviewDialogAction,
    closePreviewDialog: closePreviewDialogAction,
    openPreviewSingleDialog: openPreviewSingleDialogAction,
    closePreviewSingleDialog: closePreviewSingleDialogAction,
    setBenchmark: setBenchmarkAction,
    openEditBenchmarkContributionDialog: openEditBenchmarkContributionDialogAction,
    setContributionBenchmark: setContributionBenchmarkAction,
})

export default connect(mapStateToProps, mapDispatchToProps)(MutualAid)